import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { Box, Padding, Stack, Text } from '../../components';
import { ExpandableQuestionView, questionsAndAnswers } from './shared';

const BackgroundWrapper = styled.div`
  background-color: #fff;
`;

export const FrequentlyAskedQuestionsMobile = () => {
  return (
    <BackgroundWrapper>
      <Box
        ratio={0.8}
        backgroundImage="images/frequently-asked-questions-picture.jpg"
      />
      <Padding size={[5, 4]}>
        <Stack size={5}>
          <Padding size={[5, 0]}>
            <Text textType="heading4">Frequently Asked Questions</Text>
          </Padding>
          <div>
            {_.flow((questionsAndAnswers) =>
              _.map(questionsAndAnswers, (singleValue, index) => {
                return (
                  <ExpandableQuestionView
                    mobile
                    questionAndAnswer={singleValue}
                    key={index}
                  />
                );
              })
            )(questionsAndAnswers)}
          </div>
        </Stack>
      </Padding>
    </BackgroundWrapper>
  );
};
